import { render, staticRenderFns } from "./CreateEditUserTabs.vue?vue&type=template&id=7fbe04a5&"
import script from "./CreateEditUserTabs.vue?vue&type=script&lang=js&"
export * from "./CreateEditUserTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports